<template>
    <div class="avail_content">
      <div class="avail_search">
         <pro-search 
      :fileds="AcailableSearchFiled"
      :form="queryForm"
      @search="handleSearch"
      @reset="handleReset"
      >
        <template slot="warehouseCode">
          <div v-if="!isNowWaCustomer">
            <!-- <cascaderSelect v-if="isEnterprise" ref="cascaderSelect" @change="handleWhChange"></cascaderSelect> -->
            <select-dom v-model="queryForm.shipperId" :is-every-request="false" :list="ProjectList" @onSearch="onSearchProject" @checkedList="checkedList" />
          </div>
           <wareHouse-select  v-else :select-ware="queryForm.warehouseCodeCustomers" :option="ProjectList" @change="handleChange"/>
        </template>
      </pro-search>
      </div>
      <div class="avail_table">
        <div class="operate_bar">
          <a-button class="btn_export" @click="handleExport">导出</a-button>
        </div>
        <a-table
        :loading="tableLoading"
        :columns="TableColumns"
        :data-source="goodsData"
        class="table-sigle"
        row-key="id"
        :scroll="{ x: 'calc(700px + 50%)'}"
        :pagination="pagination"
        @change="handleTableChange"
        >
          <template slot="goodsName" slot-scope="text">
          <a-tooltip>
            <template slot="title">{{text}}</template>
             <p class="overlength"> {{text}}</p>
            </a-tooltip>
          </template>
        </a-table>
      </div>
    </div>
</template>

<script>
import SelectDom from '@/components/select/SelectDom'
import { EventBus } from '@/utils/event-bus'
// import cascaderSelect from '@/components/cascaderSelect/index.vue'
import ProSearch from '@/components/TableSearch/index.vue'
import { getWareHouse } from '../../../../warehouseOrder/api'
import {availTableColumns,AcailableSearchFiled} from '../constant'
import {shipperGoodsStockExport} from '../../../overview/api'
import wareHouseSelect from '../../component/warehouseSelect.vue'
import {warehouseStockPage} from '../../api'

  export default {
    name:'AvailableQuantity',
    components:{
      SelectDom,
      // cascaderSelect,
      ProSearch,
      wareHouseSelect
    },
    props:{
      checkTab:{
        type:String,
        default:'available-quantity'
      },
      isNowWaCustomer:{
        type:Boolean,
        default:()=>false
      }
    },
    data(){
      return {
        queryForm:{},
        ProjectList: [],
        AcailableSearchFiled,
        goodsData: [],
        isEnterprise:false,
        tableLoading:false,
        pagination: {
          current: 1,
          total: 0,
          pageSize:10,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          onShowSizeChange: (current, pageSize) => {
            this.pagination.pageSize = pageSize
          },
          showQuickJumper: true,
          showTotal: total => `共 ${total} 条`
      },
      }
    },
    computed:{
     TableColumns(){
      return availTableColumns(this.isNowWaCustomer)
     }
    },
    watch:{
      checkTab(){
         if(this.checkTab==='available-quantity'){
         this.getData();
        }
      },
      isNowWaCustomer(){
        this.getWareHouse()
      }
    },
    created() {
      // const {creditCode}=this.$store.state.user
      // if(!creditCode){
      //   this.getWareHouse()
      // }
      // this.isEnterprise=!!creditCode
    },
    methods:{
      init(){
         this.getWareHouse()
      },
      handleSearch(form){
        this.pagination.current=1
        this.queryForm={
          ...form,
        }
        this.getData();
      },
      handleWhChange(data){
        this.queryForm.warehouseCode =data.tenantId
        this.queryForm.shipperId =data.customerId
        this.ProjectList=[data]
        this.getData(true)
      },
     async handleExport(){
        const {warehouseCodes,customerIds,warehouseCode,shipperId,warehouseCodeCustomers,...restParams}=this.queryForm;
        if(!this.isNowWaCustomer&&!shipperId){
          this.$message.warning('未选择仓库,无法查询数据')
          return
        }
        const data={
          ...restParams
        };
        if(this.isNowWaCustomer){
          data.warehouseCodes=warehouseCodes;
          data.customerIds=customerIds;
        }else{
          data.warehouseCode=warehouseCode;
          data.customerIds=[shipperId];
        }
       await shipperGoodsStockExport(data)
       EventBus.$emit('taskPopover')
      },
      checkedList(data){
        this.queryForm.shipperId = data.customerId
        this.queryForm.warehouseCode = data.tenantId
        this.getData(true)
      },
      handleReset(){
        this.$refs.cascaderSelect.handleClear()
        this.pagination.current=1
        this.queryForm={}
        this.queryForm={
          // warehouseCode: this.ProjectList[0].tenantId,
          // shipperId: this.ProjectList[0].customerId,
        }
        this.getData();
      },
    onSearchProject(tenantName){
      this.getWareHouse(tenantName)
    },
    async getData(current = null){
      if(current){
        this.pagination.current = 1
      }
      this.tableLoading=true;
      const params = {
        size: this.pagination.pageSize,
        page: this.pagination.current
      }
      const {warehouseCodes,customerIds,warehouseCode,shipperId,warehouseCodeCustomers,...restParams}=this.queryForm;
      if(!this.isNowWaCustomer&&!shipperId){
        this.$message.warning('未选择仓库,无法查询数据')
        this.tableLoading=false;
        return
      }
      const data={
        ...restParams
      };
      if(this.isNowWaCustomer){
        data.warehouseCodes=warehouseCodes;
        data.customerIds=customerIds;
      }else{
        data.warehouseCode=warehouseCode;
        data.customerIds=[shipperId];
      }
      try {
        const res= await warehouseStockPage(data, params)
        this.goodsData = res.records
        this.pagination.total = res.total
        this.tableLoading=false;
      } catch (error) {
        this.goodsData = []
        this.pagination.total = 0
        this.tableLoading=false;
      }
    },
     handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current
      }
      this.getData();
    },
    getWareHouse(tenantName=null){
      const data = {
          customerCodes: [this.$store.state.user.customerCode],
          needExcludeDefaultTenant: true,
          tenantName,
          isReadConfig:true,
      }
      if(this.isNowWaCustomer){
        data.isReadConfig=true
        data.type='DELIVER'
      }
      getWareHouse(data,{size:500}).then((res) => {
        if(res.records.length <= 0){
          this.ProjectList = []
          this.$message.warning('未选择仓库,无法查询数据')
          return
        }
        const arr = res.records.map((e) => {
          if(!this.isNowWaCustomer){
            return {
                ...e,
                label: e.tenantName,
                formatLabel: `${e.tenantName} (${e.shipperName})`,
                value: e.customerId
            }
          }
            return {
                ...e,
                label: e.tenantName,
                formatLabel: `${e.tenantName} (${e.shipperName})`,
                value: e.customerId
            }
        })
        this.ProjectList = arr
        if(this.goodsData.length <= 0){
          if(arr.length > 0 && !this.queryForm.shipperId){
            if(!this.isNowWaCustomer){
              this.queryForm.warehouseCode = arr[0].tenantId;
              this.queryForm.shipperId = arr[0].customerId;
            }
          }
          this.getData()
        }
      })
    },
    handleChange(value){
      this.queryForm.customerIds=[];
      this.queryForm.warehouseCodes=[];
      this.ProjectList.forEach(item=>{
        if(value.includes(item.value)){
          this.queryForm.customerIds.push(item.customerId)
          this.queryForm.warehouseCodes.push(item.tenantId)
        }
      })
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
.avail_content {
    background-color: #fff;
    border-radius: 6px;
    padding: 24px;
}
  .avail_search {
    margin-bottom: 12px;
  }
  .avail_table {
    // background-color: #fff;
    // border-radius: 6px;
    border-top: 1px solid #E7E9EC;
    padding-top: 24px;
  }
  .avail_form {
    /deep/.ant-form-item {
      width: 100%;
      .ant-form-item-label {
        width: 80px;
      }
      .ant-form-item-control-wrapper {
        width: calc(100% - 80px);
      }
    }
    .ant-col-6 {
      padding-right: 20px;
    }
    .form-btns {
      text-align: center;
      .form-btn {
        margin-left: 20px;
      }
    }
  }
  .operate_bar {
    margin-bottom: 24px;
    .btn_export {
      border: 1px solid #06B880;
      color: #06B880;
    }
  }
   .avail_form {
    /deep/.ant-form-item-label label {
      color: #606266;
    }
    /deep/ .ant-form-item-control-wrapper input {
      color: #171717 !important;
    }

  }
  .search_btn {
    color: #06B880;
    border-color: #06B880;
  }
  .overlength {
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
</style>